import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { supabase } from "../../supabaseClient";
import AdminBottomNavigation from "./AdminBottomNavigation";
import AdminStartMatch from "./AdminStartMatch";
import AdminRaspored from "./AdminRaspored";
import AdminResultsEdit from "./AdminResultsEdit";
// import AdminAddTeams from "./AdminAddTeams";
import FSLogo from "../../Assets/Images/fucascore_png.png";
// import AdminChampionship from "./AdminChampionship";
import AdminSettings from "./AdminSettings";
import AdminAddTeamsContainer from "./AdminAddTeamsContainer";
import AdminChampionshipContainer from "./AdminChampionshipContainer";

const AdminHome = ({ session }) => {
  const [adminTab, setAdminTab] = useState("dashboard");
  const [activeAction, setActiveAction] = useState("start");
  const [settingsPage, setSettingsPage] = useState("menu");

  // State za više turnira istog organizatora i odabrani turnir
  const [turniri, setTurniri] = useState([]);
  const [selectedTurnirId, setSelectedTurnirId] = useState(null);
  const [turnir, setTurnir] = useState(null);
  const [loadingTurnir, setLoadingTurnir] = useState(true);

  // State za profilni dropdown izbornik i kopiranje slug-a
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [copied, setCopied] = useState(false);
  const dropdownRef = useRef(null);

  const navigate = useNavigate();

  // Zatvaranje dropdowna na klik izvan elementa
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDropdownOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    const checkRoleAndRedirect = async () => {
      if (!session?.user?.id) return;

      const { data: profile } = await supabase
        .from("admin_users")
        .select("role")
        .eq("id", session.user.id)
        .maybeSingle();

      if (profile?.role && profile.role.trim().toLowerCase() === "owner") {
        navigate("/fucascore-admin", { replace: true });
      }
    };

    checkRoleAndRedirect();
  }, [session, navigate]);

  // Dohvaćanje svih turnira za prijavljenog korisnika
  useEffect(() => {
    const fetchOrganizerTurniri = async () => {
      if (!session || !session?.user?.email) return;

      const cleanEmail = session.user.email.trim().toLowerCase();

      try {
        const { data, error } = await supabase
          .from("admin_turniri")
          .select("*");

        if (error) {
          console.error("Greška pri dohvaćanju turnira:", error.message);
        } else if (data && data.length > 0) {
          const matchedTurniri = data.filter(
            (t) =>
              t.whitelist_email &&
              t.whitelist_email.trim().toLowerCase() === cleanEmail,
          );

          if (matchedTurniri.length > 0) {
            // Sortiramo od najnovijeg prema starijem
            matchedTurniri.sort(
              (a, b) => new Date(b.datum_od || 0) - new Date(a.datum_od || 0),
            );

            setTurniri(matchedTurniri);
            setSelectedTurnirId(matchedTurniri[0].id);
            setTurnir(matchedTurniri[0]);
          }
        }
      } catch (err) {
        console.error("Neočekivana greška:", err);
      } finally {
        setLoadingTurnir(false);
      }
    };

    fetchOrganizerTurniri();
  }, [session]);

  // Promjena odabrane sezone/godine u padajućem izborniku
  const handleTurnirChange = (e) => {
    const targetId = e.target.value;
    setSelectedTurnirId(targetId);
    const found = turniri.find((t) => t.id === targetId);
    if (found) setTurnir(found);
  };

  // Funkcija za odjavu sa sigurnosnom provjerom
  const handleLogout = async () => {
    const confirmLogout = window.confirm(
      "Jeste li sigurni da se želite odjaviti?",
    );
    if (confirmLogout) {
      const { error } = await supabase.auth.signOut();
      if (error) {
        alert("Greška pri odjavi: " + error.message);
      } else {
        navigate("/admin-login");
      }
    }
  };

  // Kopiranje sluga turnira
  const handleCopySlug = () => {
    const turnirSlug = turnir?.slug || "turnir";
    navigator.clipboard.writeText(`https://fucascore.com/${turnirSlug}`);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  const renderContent = () => {
    if (adminTab === "dashboard") {
      switch (activeAction) {
        case "start":
          return <AdminStartMatch turnir={turnir} />;
        case "results":
          return <AdminResultsEdit turnir={turnir} />;
        case "schedule":
          return <AdminRaspored turnir={turnir} />;
        case "teams":
          return (
            <AdminAddTeamsContainer
              tournamentId={turnir?.id}
              turnir={turnir}
              onFinishTV={(targetAction = "teams") =>
                setActiveAction(targetAction)
              }
            />
          );
        default:
          return <AdminStartMatch turnir={turnir} />;
      }
    }

    if (adminTab === "bracket") {
      return (
        <AdminChampionshipContainer
          selectedTurnirId={turnir?.id}
          turnir={turnir}
        />
      );
    }

    if (adminTab === "settings") {
      return (
        <AdminSettings
          settingsPage={settingsPage}
          setSettingsPage={setSettingsPage}
          turnir={turnir}
          selectedTurnirId={turnir?.id}
        />
      );
    }
  };

  if (loadingTurnir) {
    return (
      <div style={{ color: "#fff", textAlign: "center", marginTop: "50px" }}>
        Učitavanje vašeg turnira...
      </div>
    );
  }

  return (
    <div className="admin-wrapper">
      <div className="admin-fixed-header">
        <div className="admin-navigation">
          <div style={{ display: "flex", alignItems: "center", gap: "15px" }}>
            <a href="/admin-panel">
              <img className="logo" src={FSLogo} alt="FucaScore Logo" />
            </a>
          </div>
          <div className="admin-title">
            <h1 className="title">FucaScore ADMIN</h1>
            <p>{turnir ? turnir.naziv : "ADMIN PANEL"}</p>
          </div>

          {/* Profilna ikonica i dropdown prozorčić */}
          <div className="admin-profile-container" ref={dropdownRef}>
            <button
              className="profile-icon-btn"
              onClick={() => setDropdownOpen((prev) => !prev)}
              title="Korisnički izbornik"
            >
              <i className="fi fi-rr-user"></i>
            </button>

            {dropdownOpen && (
              <div className="admin-dropdown-menu">
                <div className="dropdown-header">
                  {turnir?.logo_url && (
                    <img
                      className="dropdown-logo"
                      src={turnir.logo_url}
                      alt="Logo turnira"
                    />
                  )}

                  <div className="dropdown-info-wrap">
                    <span className="dropdown-subtitle">
                      Prijavljeni turnir:
                    </span>
                    <span className="dropdown-turnir-name">
                      {turnir ? turnir.naziv : "Nema aktivnog turnira"}
                    </span>
                  </div>
                </div>

                {/* Selektor za prebacivanje između godina / sezona */}
                {turniri.length > 1 && (
                  <div
                    className="dropdown-link-section"
                    style={{ padding: "0 15px 10px 15px" }}
                  >
                    <span
                      className="dropdown-subtitle"
                      style={{ display: "block", marginBottom: "5px" }}
                    >
                      Odaberi sezonu / godinu:
                    </span>
                    <select
                      value={selectedTurnirId || ""}
                      onChange={handleTurnirChange}
                    >
                      {turniri.map((t) => {
                        const match = t.naziv.match(/\b(20\d{2})\b/);
                        const godina = match ? match[0] : t.naziv;
                        return (
                          <option key={t.id} value={t.id}>
                            {godina}{" "}
                            {t.status === "zavrsen" ? "(Završeno)" : ""}
                          </option>
                        );
                      })}
                    </select>
                  </div>
                )}

                {turnir && (
                  <div className="dropdown-link-section">
                    <span className="dropdown-subtitle">Link turnira:</span>
                    <div className="dropdown-link-box">
                      <span className="link-text">
                        fucascore.com/{turnir.slug || "nema-sluga"}
                      </span>
                      <button
                        className="dropdown-copy-btn"
                        onClick={handleCopySlug}
                      >
                        <i
                          className={
                            copied ? "fa-solid fa-check" : "fa-regular fa-copy"
                          }
                        ></i>
                        <span>{copied ? "Kopirano!" : "Kopiraj"}</span>
                      </button>
                    </div>
                  </div>
                )}

                <div className="dropdown-footer">
                  <button
                    className="dropdown-logout-btn"
                    onClick={handleLogout}
                  >
                    <i className="fa-solid fa-right-from-bracket"></i>
                    Odjavi se
                  </button>
                </div>
              </div>
            )}
          </div>
        </div>

        {adminTab === "dashboard" && (
          <div className="admin-top-nav">
            <button
              className={activeAction === "start" ? "active" : ""}
              onClick={() => setActiveAction("start")}
            >
              Pokreni Utakmicu
            </button>
            <button
              className={activeAction === "results" ? "active" : ""}
              onClick={() => setActiveAction("results")}
            >
              Uredi Rezultate
            </button>{" "}
            <button
              className={activeAction === "schedule" ? "active" : ""}
              onClick={() => setActiveAction("schedule")}
            >
              Uredi Raspored
            </button>
            <button
              className={activeAction === "teams" ? "active" : ""}
              onClick={() => setActiveAction("teams")}
            >
              Uredi Grupe
            </button>
          </div>
        )}
      </div>

      <div className="admin-content-scrollable">{renderContent()}</div>

      <AdminBottomNavigation
        adminTab={adminTab}
        setAdminTab={(tab) => {
          setAdminTab(tab);
          if (tab === "settings") setSettingsPage("menu");
        }}
      />
    </div>
  );
};

export default AdminHome;
